import { Resource } from 'src/app/global/domain/resource.model';

export class CategoriaPlanoConta extends Resource {
  codigo: string;
  descricao: string;
  parent: CategoriaPlanoConta;
  subcategorias: CategoriaPlanoConta[];
}
